(function() {
    'use strict';
  
    // Only run on the specific product page
    if (window.location.pathname !== '/products/mte-daily-energy-wellness') {
        return;
    }
    
    function setupRechargeServingsUpdater() {
        let observer = null;
        
        function updateServings() {
            const rcWidget = document.querySelector('.rc-widget');
            
            if (rcWidget) {
                const servingSpans = rcWidget.querySelectorAll('span.product-option-item');
                let updated = false;
                
                servingSpans.forEach(span => {
                    if (span.textContent.includes('30 Servings')) {
                        const svg = span.querySelector('svg');
                        if (svg) {
                            span.innerHTML = '';
                            span.appendChild(svg);
                            span.appendChild(document.createTextNode(' 24 Servings'));
                        } else {
                            span.textContent = span.textContent.replace('30 Servings', '24 Servings');
                        }
                        updated = true;
                    }
                });
                
                if (updated && window.console) {
                    console.log('Recharge: Updated serving size to 24');
                }
                
                if (!observer) {
                    observer = new MutationObserver(function(mutations) {
                        mutations.forEach(function(mutation) {
                            if (mutation.type === 'childList') {
                                mutation.addedNodes.forEach(function(node) {
                                    if (node.nodeType === 1 && node.textContent && node.textContent.includes('30 Servings')) {
                                        setTimeout(updateServings, 100);
                                    }
                                });
                            }
                            if (mutation.type === 'characterData' && mutation.target.textContent.includes('30 Servings')) {
                                setTimeout(updateServings, 100);
                            }
                        });
                    });
                    
                    observer.observe(rcWidget, {
                        childList: true,
                        subtree: true,
                        characterData: true,
                        characterDataOldValue: true
                    });
                }
            } else {
                setTimeout(setupRechargeServingsUpdater, 1000);
            }
        }
        
        updateServings();
    }
    
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', setupRechargeServingsUpdater);
    } else {
        setupRechargeServingsUpdater();
    }
    
    setTimeout(setupRechargeServingsUpdater, 1000);
    setTimeout(setupRechargeServingsUpdater, 3000);
})();